module.exports = __webpack_public_path__ + "static/media/YF104_2.85297c1e.jpg";